{
  "upcoming": [
    "Singapore 2025",
    "Vietnam (English and Local) 2025",
    "Malaysia 2025",
    "Western Australia 2025",
    "Taiwan - Local Language 2025",
    "Egypt 2026",
    "United Kingdom 2025",
    "Canada Federal 2026",
    "Nigeria 2026",
    "Netherlands 2026",
    "Sweden 2026"
  ],

  "jurisdiction": [
    {
      "country": "Argentina",
      "color": "g",
      "tips": "2025 Release Available"
    },
    {
      "country": "Australia",
      "color": "y",
      "tips": "Federal, Territories and States Available"
    },
    { "country": "Austria", "color": "y", "tips": "2024 Release Available" },
    {
      "country": "Bangladesh",
      "color": "b",
      "tips": "2024 Release Available"
    },
    {
      "country": "Belgium",
      "color": "b",
      "tips": "2025 English and Dutch Local Language Release Available"
    },
    {
      "country": "Brazil",
      "color": "b",
      "tips": "2025 English and Local Language Release Available"
    },
    {
      "country": "Canada",
      "color": "g",
      "tips": "Federal and Provinces Available Yearly"
    },
    {
      "country": "Chile",
      "color": "r",
      "tips": "2025 Release Available and Local Language Release Available"
    },
    {
      "country": "China",
      "color": "b",
      "tips": "Federal English and Local Language Available Yearly and Provinces Available Biennially"
    },
    { "country": "Colombia", "color": "g", "tips": "2025 Release Available" },
    {
      "country": "Czech Rep.",
      "color": "g",
      "tips": "2024 English and Local Language Release Available"
    },
    { "country": "Denmark", "color": "g", "tips": "COMING SOON" },
    {
      "country": "Dominican Rep.",
      "color": "g",
      "tips": "2024 Release and Local Language Release Available"
    },
    { "country": "Egypt", "color": "y", "tips": "2024 Release Available" },
    { "country": "Fiji", "color": "g", "tips": "2024 Release Available" },
    {
      "country": "France",
      "color": "b",
      "tips": "2025 English and Local Language Release Available"
    },
    {
      "country": "Germany",
      "color": "r",
      "tips": "Federal Enlgish and Local Language Available Yearly and States Available Biennially"
    },
    {
      "country": "Guatemala",
      "color": "y",
      "tips": "2024 Release Available"
    },
    {
      "country": "United Kingdom",
      "color": "y",
      "tips": "Updates Available Yearly"
    },
    { "country": "Greece", "color": "y", "tips": "2025 Release Available" },
    { "country": "Hungary", "color": "g", "tips": "2024 Release Available" },
    {
      "country": "Hong Kong",
      "color": "r",
      "tips": "2025 Release Available"
    },
    {
      "country": "Indonesia",
      "color": "r",
      "tips": "2025 Release Available"
    },
    {
      "country": "India",
      "color": "g",
      "tips": "Federal Available Yearly and States Available Biennially"
    },
    { "country": "Ireland", "color": "r", "tips": "2024 Release Available" },
    { "country": "Israel", "color": "y", "tips": "2024 Release Available" },
    {
      "country": "Italy",
      "color": "y",
      "tips": "Federal English and Local Language Available Yearly"
    },
    {
      "country": "Japan",
      "color": "y",
      "tips": "2025 English and Local Language Release Available"
    },
    {
      "country": "Kenya",
      "color": "y",
      "tips": "Comming Soon"
    },
    {
      "country": "Lithuania",
      "color": "g",
      "tips": "2024 Release Available"
    },
    { "country": "Luxembourg", "color": "g", "tips": "COMING SOON" },
    {
      "country": "Mexico",
      "color": "r",
      "tips": "Federal English and Local Language Available Yearly and States Available Biennially"
    },
    { "country": "Malaysia", "color": "r", "tips": "2024 Release Available" },
    {
      "country": "Netherlands",
      "color": "g",
      "tips": "2024 Release Available and Local Language Available"
    },
    {
      "country": "New Caledonia",
      "color": "g",
      "tips": "2024 Release Available"
    },
    {
      "country": "New Zealand",
      "color": "g",
      "tips": "2024 Release Available"
    },
    { "country": "Norway", "color": "g", "tips": "2025 Release Available" },
    { "country": "Pakistan", "color": "b", "tips": "2024 Release Available" },
    {
      "country": "Papua New Guinea",
      "color": "g",
      "tips": "2024 Release Available"
    },
    { "country": "Peru", "color": "b", "tips": "2024 Release Available" },
    {
      "country": "Philippines",
      "color": "g",
      "tips": "2025 Release Available"
    },
    { "country": "Poland", "color": "g", "tips": "2025 Release Available" },
    { "country": "Portugal", "color": "g", "tips": "2024 Release Available" },
    { "country": "Romania", "color": "r", "tips": "2024 Release Available" },
    { "country": "Russia", "color": "r", "tips": "2024 Release Available" },
    {
      "country": "Saudi Arabia",
      "color": "y",
      "tips": "2024 Release Available"
    },
    { "country": "Serbia", "color": "g", "tips": "COMING SOON" },
    {
      "country": "Singapore",
      "color": "y",
      "tips": "2024 Release Available"
    },
    { "country": "Slovenia", "color": "g", "tips": "COMING SOON" },
    {
      "country": "South Africa",
      "color": "y",
      "tips": "2025 Release Available"
    },
    {
      "country": "Korea",
      "color": "y",
      "tips": "2024 English and Local Language Release Available"
    },
    {
      "country": "Spain",
      "color": "y",
      "tips": "2025 English and Local Language Release Available"
    },
    { "country": "Sweden", "color": "y", "tips": "2023 Release Available" },
    {
      "country": "Switzerland",
      "color": "b",
      "tips": "2025 Release Available"
    },
    { "country": "Thailand", "color": "b", "tips": "2024 Release Available" },
    {
      "country": "Taiwan",
      "color": "b",
      "tips": "2025 English and Local Language Release Available"
    },
    { "country": "Turkey", "color": "b", "tips": "2025 Release Available" },
    { "country": "Ukraine", "color": "b", "tips": "Coming Soon" },
    {
      "country": "United Arab Emirates",
      "color": "b",
      "tips": "2024 Federal and Emirates Available"
    },
    {
      "country": "United States",
      "color": "b",
      "tips": "Federal and State Available Quarterly"
    },
    { "country": "Uruguay", "color": "y", "tips": "2026 Release Available" },
    { "country": "Uzbekistan", "color": "g", "tips": "COMING SOON" },
    {
      "country": "Venezuela",
      "color": "b",
      "tips": "2025 Release Available"
    },
    {
      "country": "Vietnam",
      "color": "b",
      "tips": "2023 English and Local Language Release Available"
    }
  ]
}
